import { initializeMarketingAttribution } from './attribution';

initializeMarketingAttribution();
